export const environment = {

  production: false,
  mapbox: {
    accessToken: 'pk.eyJ1IjoiZ2hhc2VtaW1hcmFsIiwiYSI6ImNtZHp3cmp5ajBlYTQyanNoajV5bDlxbzYifQ.DqiRiyDGe2YG6VWpzZMsFg'
  },
  mapquest: {
    accessToken:""
  },
  apis: {
    url: 'http://staging01.intern.tal.de/api'
  },
  website: {
    url: 'http://staging01.intern.tal.de/'
  },
  tokenName: 'eyes-token'
};
